<template>
    <main class="home regulations">
        <div class="wrapper">
            <h1 class="home__title">
                Regulamin świadczenia usług w ramach serwisu
                <router-link to="/">www.racer-online.pl</router-link>
            </h1>

            <ol class="regulations__list">
                <li>
                    <h3 class="home__title">Postanowienia ogólne</h3>
                </li>
                <ol>
                    <li>
                        Niniejszy regulamin (zwany dalej: „Regulamin”) określa zasady korzystania przez użytkowników
                        (dalej „Użytkownicy”)
                        niebędących konsumentami w rozumieniu przepisu art. 221 Kodeksu cywilnego z usług interaktywnych
                        (dalej „Usługi”)
                        świadczonych przez Usługodawcę za pomocą serwisu internetowego zlokalizowanego pod adresem
                        <router-link to="/">www.racer-online.pl</router-link>
                        (dalej: „Serwis”) przy pomocy konta Użytkownika założonego przez niego w Serwisie zgodnie z
                        zasadami określonymi w
                        Regulaminie (dalej „Konto”).
                    </li>
                    <li>
                        Usługodawcą i właścicielem Serwisu jest WHITE SOLUTION Sp. z o.o. Sp. k. zarejestrowana w
                        Polsce, z siedzibą w
                        Łodzi, ul. Traugutta 5/4, wpisaną do rejestru prowadzonego przez Sąd Rejonowy Łodzi-Śródmieścia
                        w Łodzi, XX
                        Krajowego Rejestru Sądowego, pod numerem KRS 0000724543, NIP: 725-226-66-75 (dalej "WHITE
                        SOLUTION").
                    </li>
                    <li>
                        Niniejszy Regulamin jest regulaminem, o którym mowa w art. 8 ustawy z dnia 18 lipca 2002r. o
                        świadczeniu usług
                        drogą elektroniczną (Dz. U. nr 144, poz. 1204 ze zm.).
                    </li>
                    <li>
                        Świadczenie Usług przez WHITE SOLUTION polega na umożliwieniu zarejestrowanym Użytkownikom
                        korzystania z Serwisu,
                        stanowiącego platformę interaktywną do edukacji online zgodnych z przedmiotem prowadzonego
                        Projektu edukacyjnego
                        ‘Racer’ przez WHITE SOLUTION.
                    </li>
                    <li>
                        Korzystanie z Usług oferowanych w Serwisie oraz rejestracja w Serwisie i założenie Konta wymaga
                        wyrażenia zgody na
                        warunki sformułowane w niniejszym Regulaminie.
                    </li>
                    <li>
                        Dostęp do Usług oferowanych w Serwisie mają tylko zarejestrowani Użytkownicy Serwisu, którzy
                        dokonali rejestracji
                        w Serwisie i założyli w ten sposób Konto.
                    </li>
                    <li>
                        WHITE SOLUTION zastrzega sobie prawo do wycofania lub modyfikacji funkcjonalności Serwisu ze
                        względów natury
                        prawnej lub technicznej, w tym:
                    </li>
                    <ol>
                        <li>
                            względów ochrony prywatności danych lub innych prawnych względów związanych z zawartością
                            lub sposobem
                            działania Serwisu;
                        </li>
                        <li>trudności technicznych związanych z działalnością Serwisu lub Internetu.</li>
                    </ol>
                    <li>
                        Usługodawca nie ponosi odpowiedzialności za niedostępność Serwisu z przyczyn od niego
                        niezależnych oraz z powodu
                        nieprzewidzianych okoliczności.
                    </li>
                    <li>
                        WHITE SOLUTION zastrzega sobie ponadto możliwość zawieszenia lub zakończenia świadczenia Usług w
                        dowolnym
                        momencie, z dowolnych przyczyn. W takim wypadku zarejestrowani Użytkownicy zostaną o tym fakcie
                        powiadomieni z
                        odpowiednim wyprzedzeniem.
                    </li>
                    <li>
                        Do prawidłowego korzystania z Serwisu niezbędne jest: posiadanie komputera, laptopa lub innego
                        urządzenia
                        multimedialnego, posiadanie dostępu do sieci Internet, korzystanie ze standardowego
                        oprogramowania w postaci systemu
                        operacyjnego oraz przeglądarki internetowej, przy czym przeglądarka internetowa powinna
                        obsługiwać pliki „cookies”
                        (szczegółowe zasady wykorzystania plików cookies znajdują się w Polityce Prywatności),
                        posiadanie własnego,
                        aktywnego adresu poczty elektronicznej.
                    </li>
                    <li>W przypadku braku spełnienia powyższych wymogów korzystanie z Serwisu może być utrudnione lub
                        niemożliwe.
                    </li>
                </ol>
                <li>
                    <h3 class="home__title">Członkostwo i rejestracja w Serwisie</h3>
                </li>
                <ol>
                    <li>
                        W celu pełnego korzystania z Serwisu niezbędne jest dokonanie rejestracji w Serwisie i założenie
                        w ten sposób
                        Konta.
                    </li>
                    <li>
                        Użytkownikami Serwisu mogą być wyłącznie osoby fizyczne posiadające pełną zdolność do czynności
                        prawnych, osoby
                        prawne lub jednostki organizacyjne nieposiadającej osobowości prawnej, którym ustawa przyznaje
                        zdolność prawną,
                        prowadzące we własnym imieniu działalność gospodarczą lub zawodową i posiadające miejsce
                        zamieszkania lub siedzibę
                        na terytorium Rzeczypospolitej Polskiej, które zawarły z Usługodawcą umowę o korzystanie z
                        Serwisu i założyły w ten
                        sposób Konto.
                    </li>
                    <li>Rejestracja i założenie Konta w Serwisie jest bezpłatne. Każdy Użytkownik może założyć tylko
                        jedno Konto.
                    </li>
                    <li>
                        Użytkownik chcąc założyć w Serwisie Konto, wypełnia i wysyła do WHITE SOLUTION odpowiedni
                        formularz rejestracyjny,
                        znajdujący się na podstronie Serwisu. Formularz rejestracyjny stanowi ofertę Usługodawcy
                        skierowaną do przyszłego
                        Użytkownika w przedmiocie zawarcia umowy o korzystanie z Serwisu.
                    </li>
                    <li>
                        W formularzu rejestracyjnym przyszły Użytkownik zobowiązany jest do podania następujących
                        danych: imię, nazwisko,
                        login (adres e-mail), hasło (min. 6 znaków, w tym przynajmniej 1 litera i 1 cyfra), numer Prawa
                        Wykonywania Zawodu
                        (dalej „PWZ”), numer telefonu oraz adres do korespondencji. W przypadku osoby prawnej lub
                        jednostki organizacyjnej
                        nieposiadającej osobowości prawnej, której ustawa przyznaje zdolność prawną należy wskazać PWZ
                        osoby uprawnionej do
                        reprezentacji podmiotu, posiadającej PWZ. Niepodanie danych uniemożliwi rejestrację i założenie
                        Konta.
                    </li>
                    <li>Zabronione jest dodawanie w formularzu rejestracyjnym treści o charakterze bezprawnym.</li>
                    <li>
                        Wysłanie formularza rejestracyjnego do WHITE SOLUTION stanowi przyjęcie oferty WHITE SOLUTION na
                        zawarcie umowy o
                        korzystanie z Serwisu na warunkach określonych w niniejszym Regulaminie.
                    </li>
                    <li>
                        WHITE SOLUTION, po zawarciu umowy o korzystanie z Serwisu, przesyła na podany przez Użytkownika
                        adres poczty
                        elektronicznej wiadomość z potwierdzeniem założenia Konta.
                    </li>
                    <li>
                        Umowa o korzystanie z Serwisu zawarta jest na czas nieokreślony. Zarówno Użytkownik jak i WHITE
                        SOLUTION jest
                        uprawniony do wypowiedzenia umowy o korzystanie z Serwisu w każdym czasie i bez podania
                        przyczyny. Wypowiedzenie
                        umowy następuje z zachowaniem 7-dniowego okresu wypowiedzenia. Wypowiedzenie umowy może nastąpić
                        w formie pisemnej
                        lub mailem na adres poczty elektronicznej.
                    </li>
                    <li>
                        Użytkownik powinien stosować odpowiednie środki techniczne w celu zapobieżenia pozyskania lub
                        modyfikowania danych
                        Użytkownika przez osoby nieuprawnione. WHITE SOLUTION nie ponosi odpowiedzialności za
                        niezastosowanie przez
                        Użytkownika odpowiednich środków technicznych.
                    </li>
                    <li>
                        WHITE SOLUTION może żądać od Użytkownika dokumentów potwierdzających prowadzenie przez niego
                        działalności
                        gospodarczej. Jeżeli Użytkownik nie jest osobą fizyczną, wówczas osoba działająca w imieniu i na
                        rzecz Użytkownika
                        zobowiązana jest do udokumentowania na każde wezwanie WHITE SOLUTION posiadania prawa do
                        reprezentacji Użytkownika.
                    </li>
                    <li>Użytkownik zobowiązuje się zachować swoje hasło w tajemnicy.</li>
                    <li>
                        W przypadku stwierdzenia, że dane Konta (login, hasło) są bezprawnie wykorzystywane przez osoby
                        trzecie,
                        Użytkownik zobowiązany jest poinformować o zaistniałym fakcie WHITE SOLUTION.
                    </li>
                    <li>
                        Ze względów bezpieczeństwa lub innych istotnych względów organizacyjnych lub technicznych WHITE
                        SOLUTION może
                        żądać od Użytkowników zmiany hasła lub innych informacji wykorzystywanych dla uzyskania dostępu
                        do Serwisu.
                    </li>
                    <li>
                        Niedopuszczalne jest korzystanie w Serwisie z Kont innych Użytkowników lub odstępowanie swojego
                        Konta innym
                        osobom.
                    </li>
                    <li>
                        Użytkownik wyraża zgodę na dostęp WHITE SOLUTION do informacji zgromadzonych na Koncie m.in. w
                        celu weryfikacji
                        ewentualnych naruszeń Regulaminu lub przepisów prawa.
                    </li>
                </ol>
                <li>
                    <h3 class="home__title">Polityka prywatności w Serwisie</h3>
                </li>
                <ol>
                    <li>
                        WHITE SOLUTION posługuje się plikami typu cookies w celu gromadzenia informacji związanych
                        korzystaniem z Serwisu
                        przez Użytkownika. Pliki cookies umożliwiają zidentyfikowanie komputera Użytkownika, w celu
                        zapewnienia że Konto
                        jest używane przez osobę, która wprowadza do niego poprawne Login i Hasło do Konta.
                    </li>
                    <li>Szczegółowe informacje na temat stosowania plików cookies znajdują się w Polityce Prywatności.
                    </li>
                    <li>
                        Bez uprzedniej zgody WHITE SOLUTION niedopuszczalne jest ujawnianie i wykorzystywanie informacji
                        dostępnych
                        wyłącznie zarejestrowanym Użytkownikom Serwisu.
                    </li>
                </ol>
                <li>
                    <h3 class="home__title">Zasady korzystania z serwisu oraz eliminacja nadużyć</h3>
                </li>
                <ol>
                    <li>Serwis powinien być używany przez Użytkowników dla celów, o których mowa w punkcie 1.4.
                        powyżej.
                    </li>
                    <li>
                        Niedozwolonym jest korzystanie z usług Serwisu w celu naruszającym obowiązujące prawo oraz
                        dostarczanie przez
                        Użytkownika do Serwisu treści o charakterze bezprawnym.
                    </li>
                    <li>Użytkownicy ponoszą wyłączną odpowiedzialność za zgodność ich działań w ramach Serwisu z
                        obowiązującym prawem.
                    </li>
                    <li>
                        Użytkownikom nie wolno posługiwać się nieuczciwymi metodami w korzystaniu z Serwisu. Ponadto,
                        zabronione jest
                        podejmowanie przez Użytkowników działań mogących wywrzeć skutek w postaci przerwania lub
                        zaburzeń w funkcjonowaniu
                        Serwisu.
                    </li>
                    <li>
                        WHITE SOLUTION zastrzega sobie prawo do zawieszenia lub odmowy dostępu któregokolwiekz
                        Użytkowników do Serwisu lub
                        jego części, jeżeli zachowanie Użytkownika stanowi naruszenie Regulaminu. Podmiot, którego
                        zawieszenie lub odmowa
                        dotyczy, nie może dokonać powtórnej rejestracji lub korzystać z Serwisu bez uprzedniej zgody
                        WHITE SOLUTION.
                    </li>
                    <li>
                        Użytkownik odpowiedzialny jest za wszelkie działania podejmowane w Serwisie lub z użyciem
                        Serwisu dokonywane z
                        użyciem swojego loginu i hasła.
                    </li>
                    <li>
                        Użytkownik odpowiedzialny jest za to, że żadna informacja przesłana przez niego do Serwisu, jak
                        również żadne
                        działanie lub wysłana wiadomość będące w związku z Serwisem, nie będzie:
                    </li>
                    <ol>
                        <li>stanowić naruszenia praw własności intelektualnej jakiejkolwiek osoby lub jakiegokolwiek
                            przedsiębiorstwa;
                        </li>
                        <li>stanowić naruszenia obowiązującego prawa, w tym przepisów karnych;</li>
                        <li>
                            nosić znamiona działań obraźliwych, grożących, naruszających przyjęte normy obyczajowe,
                            dopuszczającego się
                            obrazy uczuć religijnych, o charakterze pornograficznym, fałszywych, niewiarygodnych lub
                            wprowadzających w błąd.
                        </li>
                    </ol>
                    <li>
                        Każdy Użytkownik przyjmuje do wiadomości, że WHITE SOLUTION uprawniony jest do wycofania z
                        Serwisu jakiejkolwiek
                        informacji, co do której, bazując na własnych źródłach informacji lub opierając się na
                        doniesieniach Użytkowników
                        lub innych osób lub organów, stwierdzono, że może on stanowić naruszenie niniejszego Regulaminu,
                        obowiązujących
                        przepisów prawa lub stanowić zagrożenie dla dobrego imienia WHITE SOLUTION lub Serwisu.
                    </li>
                </ol>
                <li>
                    <h3 class="home__title">Odpowiedzialność WHITE SOLUTION</h3>
                </li>
                <ol>
                    <li>
                        WHITE SOLUTION ponosi odpowiedzialność wyłącznie za szkodę wyrządzoną Użytkownikowi wyłącznie z
                        winy umyślnej w
                        związku z wykonywaniem jakiejkolwiek umowy zawartej na podstawie Regulaminu.
                    </li>
                    <li>
                        WHITE SOLUTION odpowiada wyłącznie za zawinione uchybienia w wykonywaniu jego obowiązków
                        wynikających z
                        niniejszego Regulaminu.
                    </li>
                    <li>
                        WHITE SOLUTION nie ponosi odpowiedzialności za ewentualne straty lub szkody poniesione przez
                        Użytkownika w wyniku:
                        działania siły wyższej, przerwy w dostawie prądu, sporu pracowniczego, przepisów prawa,
                        zaniedbania lub braku
                        działania ze strony władz, awarii usług telekomunikacyjnych lub jakichkolwiek opóźnień bądź
                        awarii spowodowanych
                        przez osoby trzecie. W takich przypadkach WHITE SOLUTION zastrzega sobie prawo do anulowania lub
                        zawieszenia swoich
                        usług bez ponoszenia jakiejkolwiek odpowiedzialności z tego tytułu.
                    </li>
                    <li>
                        WHITE SOLUTION nie ponosi odpowiedzialności za awarie sprzętu Użytkownika lub oprogramowania, z
                        którego korzysta,
                        bez względu na jego lokalizację i miejsce administracji, które mogą uniemożliwić funkcjonowanie
                        usług Serwisu lub
                        kontaktowanie się Użytkownika z Serwisem.
                    </li>
                    <li>
                        Użytkownicy ponoszą odpowiedzialność za zgodność swoich działań podejmowanych w ramach Serwisu z
                        obowiązującym
                        prawem a zwłaszcza ustawą Prawo farmaceutyczne.
                    </li>
                </ol>
                <li>
                    <h3 class="home__title">Własność intelektualna</h3>
                </li>
                <ol>
                    <li>
                        Wszelkie prawa autorskie, znaki towarowe i inne prawa własności intelektualnej odnoszące się do
                        Serwisu lub w nim
                        wykorzystane, inne niż informacje wniesione do Serwisu przez Użytkowników, stanowią przedmiot
                        praw WHITE SOLUTION.
                        Nikt nie może kopiować, rozpowszechniać, prezentować publicznie lub sporządzać jakichkolwiek
                        utworów zależnych na
                        podstawie Serwisu lub jakichkolwiek innych informacji uzyskanych z Serwisu bez uzyskania
                        uprzedniej zgody WHITE
                        SOLUTION lub Użytkowników, od których informacje pochodzą. 6.2. Zabronione jest korzystanie z
                        tych praw własności
                        intelektualnej przysługujących Usługodawcy do celów innych niż te ściśle związane z korzystania
                        z Serwisu w sposób
                        określony niniejszym Regulaminem.
                    </li>
                </ol>
                <li>
                    <h3 class="home__title">Postępowanie reklamacyjne</h3>
                </li>
                <ol>
                    <li>
                        Wszelkie reklamacje dotyczące świadczenia usług w Serwisie należy zgłaszać do WHITE SOLUTION na
                        następujący adres
                        poczty elektronicznej: kontakt@racer-online.pl.
                    </li>
                    <li>
                        Reklamacja powinna zawierać co najmniej: login składającego reklamację, dokładny opis i powód
                        reklamacji. 7.3.
                        Reklamacje rozpatrywane będą przez WHITE SOLUTION niezwłocznie po ich otrzymaniu, w kolejności
                        daty wpływu.
                    </li>
                </ol>
                <li>
                    <h3 class="home__title">Dane osobowe</h3>
                </li>
                <ol>
                    <li>
                        Administratorem danych osobowych jest WHITE SOLUTION Sp. z o.o. Sp. k. zarejestrowana w Polsce,
                        z siedzibą w
                        Łodzi, ul. Traugutta 5/4, wpisana do rejestru prowadzonego przez Sąd Rejonowy Łodzi-Śródmieścia
                        w Łodzi, XX
                        Krajowego Rejestru Sądowego, pod numerem KRS 0000724543, NIP: 725-226-66-75 (dalej "WHITE
                        SOLUTION"). Z WHITE
                        SOLUTION można skontaktować się pod w/w adresem lub mailowo pod adresem office@whitesolution.pl
                    </li>
                    <li>
                        Przetwarzanie danych osobowych odbywa się zgodnie z zasadami określonymi w Rozporządzeniu
                        Parlamentu Europejskiego
                        i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z
                        przetwarzaniem danych
                        osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE
                        (ogólne rozporządzenie o
                        ochronie danych) z dnia 27 kwietnia 2016 r. (dalej „RODO” lub „Rozporządzenie”), ustawie o
                        świadczeniu usług drogą
                        elektroniczną i innych powszechnie obowiązujących przepisach prawa.
                    </li>
                    <li>
                        Dane osobowe będą przetwarzane przez WHITE SOLUTION w celach: Użytkownik, chcący założyć Konto,
                        w trakcie
                        wypełniania formularza rejestracyjnego, wyraża zgodę na gromadzenie i przetwarzanie przez WHITE
                        SOLUTION danych
                        osobowych podanych w formularzu rejestracyjnym:
                    </li>
                    <ol>
                        <li>
                            realizacji umowy o korzystanie z Serwisu oraz realizacji Usług udostępnianych za
                            pośrednictwem Serwisu,
                            zgodnych z przedmiotem prowadzonego Projektu edukacyjnego ‘Racer’ – podstawą prawną tego
                            przetwarzania jest art.
                            art. 6 ust. 1 lit. b) Rozporządzenia (przetwarzanie jest niezbędne do wykonania umowy,
                            której stroną jest osoba,
                            której dane dotyczą, lub do podjęcia działań na żądanie osoby, której dane dotyczą, przed
                            zawarciem umowy),
                        </li>
                        <li>
                            prawidłowego prowadzenia Serwisu i Projektu edukacyjnego ‘Racer’ - podstawą prawną tego
                            przetwarzania jest art.
                            6 ust. 1 lit f) Rozporządzenia (przetwarzanie jest niezbędne do celów wynikających z prawnie
                            uzasadnionych
                            interesów realizowanych przez administratora lub osobę trzecią),
                        </li>
                        <li>
                            realizacji prawnie uzasadnionego interesu WHITE SOLUTION, jakim jest ewentualne ustalenie,
                            dochodzenie lub
                            obrona przed roszczeniami wynikającymi z realizacji umowy o korzystanie z Serwisu oraz
                            realizacji Usług
                            udostępnianych za pośrednictwem Serwisu, zgodnie z przedmiotem i celem Projektu edukacyjnego
                            ‘Racer’ - podstawą
                            prawną tego przetwarzania jest art. 6 ust. 1 lit f) Rozporządzenia (przetwarzanie jest
                            niezbędne do celów
                            wynikających z prawnie uzasadnionych interesów realizowanych przez administratora lub osobę
                            trzecią)..
                        </li>
                    </ol>
                    <li>
                        Użytkownik, chcący założyć Konto, w trakcie wypełniania formularza rejestracyjnego, wyraża zgodę
                        na gromadzenie i
                        przetwarzanie przez WHITE SOLUTION danych osobowych podanych w formularzu rejestracyjnym, o
                        których mowa w pkt. 2.5.
                        Regulaminu.
                    </li>
                    <li>
                        Podanie danych osobowych w celach wskazanych w pkt 8.3. Regulaminu jest dobrowolne, lecz
                        konieczne do realizacji
                        umowy o korzystanie z Serwisu oraz realizacji Usług udostępnianych za pośrednictwem Serwisu,
                        zgodnie z przedmiotem i
                        celem Projektu edukacyjnego ‘Racer’.
                    </li>
                    <li>
                        Użytkownikowi przysługuje prawo do dostępu do swoich danych osobowych, do ich poprawiania oraz
                        żądania ich
                        usunięcia, a także prawo do przenoszenia danych oraz żądania ograniczenia przetwarzania danych
                        osobowych.
                    </li>
                    <li>
                        W przypadku wniesienia sprzeciwu wobec przetwarzania danych osobowych, WHITE SOLUTION
                        zaprzestanie przetwarzać te
                        dane, chyba że będzie w stanie wykazać, że w stosunku do danych osobowych Użytkownika istnieją
                        ważne prawnie
                        uzasadnione podstawy, które są nadrzędne wobec interesów, praw i wolności Użytkownika lub gdy
                        dane te będą niezbędne
                        do ewentualnego ustalenia, dochodzenia lub obrony roszczeń.
                    </li>
                    <li>
                        W razie uznania, że dane osobowe będą przetwarzane niezgodnie z wymogami prawa, Użytkownik ma
                        prawo wnieść skargę
                        do organu nadzorczego, którym jest Prezes Urzędu Ochrony Danych Osobowych.
                    </li>
                    <li>
                        WHITE SOLUTION może przekazać dane osobowe Użytkowników innemu podmiotowi, zapewniającemu
                        wystarczające gwarancje
                        wdrożenia odpowiednich środków technicznych i organizacyjnych, tak by przetwarzanie danych było
                        zgodne z prawem i
                        chroniło prawa przysługujące Użytkownikom. Odbiorcami danych osobowych przetwarzanych przez
                        WHITE SOLUTION będą
                        wyłącznie upoważnieni pracownicy WHITE SOLUTION, a także podmioty współpracujące z WHITE
                        SOLUTION – np. w zakresie
                        świadczenia usług obsługi płatności, wsparcia IT, hostingu, reklamowe, telekomunikacyjne,
                        prawne, księgowe, a także
                        organy administracji.
                    </li>
                    <li>
                        WHITE SOLUTION nie będzie podejmować decyzji opartych wyłącznie na zautomatyzowanym
                        przetwarzaniu, w tym w formie
                        profilowania.
                    </li>
                    <li>
                        WHITE SOLUTION nie będą przekazywać gromadzonych danych osobowych (za wyjątkiem Google
                        Analytics, o którym mowa w
                        Polityce Prywatności) do państwa trzeciego ani żadnej organizacji międzynarodowej.
                    </li>
                    <li>
                        Dane osobowe będą przetwarzane przez WHITE SOLUTION w celach wskazanych w pkt 8.3. niniejszego
                        Regulaminu przez
                        czas wykonywania usług, nie dłużej niż do czasu upływu terminów przedawnienia ewentualnych
                        roszczeń wynikających z
                        realizacji usług lub wiążących obowiązków podatkowych lub do momentu otrzymania sprzeciwu osoby,
                        której dane
                        dotyczą.
                    </li>
                    <li>
                        Dane osobowe będą przetwarzane przez WHITE SOLUTION w innych celach niż wskazane w pkt 8.3.
                        przez czas wykonywania
                        usług, a później nie dłużej niż do czasu upływu terminów przedawnienia ewentualnych roszczeń
                        wynikających z
                        realizacji usług lub wiążących obowiązków podatkowych lub do momentu otrzymania sprzeciwu osoby,
                        której dane
                        dotyczą.
                    </li>
                </ol>
                <li>
                    <h3 class="home__title">Postanowienia końcowe.</h3>
                </li>
                <ol>
                    <li>
                        W kwestiach nieuregulowanych niniejszym Regulaminem stosuje się przepisy Kodeksu cywilnego oraz
                        innych powszechnie
                        obowiązujących przepisów.
                    </li>
                    <li>
                        Usługodawca zastrzega sobie prawo do wprowadzania zmian w niniejszym Regulaminie. Zmiany
                        Regulaminu zostaną
                        ogłoszone w Serwisie w postaci zamieszczenia zmienionej wersji Regulaminu. Użytkownicy zostaną
                        ponadto o zmianie
                        powiadomieni przy pomocy informacji przesłanej na adres poczty elektronicznej podany przy
                        rejestracji w Serwisie.
                        Zmiany Regulaminu wejdą w życie po upływie 7 dni od dnia przesłania informacji o której mowa w
                        zdaniu
                        poprzedzającym.
                    </li>
                    <li>
                        Uznanie poszczególnych postanowień niniejszego Regulaminu w sposób przewidziany prawem za
                        nieważne bądź
                        nieskuteczne, nie wpływa na ważność czy skuteczność pozostałych postanowień Regulaminu.
                    </li>
                    <li>Do oceny praw i obowiązków WHITE SOLUTION oraz osób korzystających z Serwisu zastosowanie
                        znajduje prawo polskie.
                    </li>
                    <li>
                        Wszelkie spory wynikłe z tytułu wykonania zobowiązań związanych z niniejszym Regulaminem i
                        korzystaniem z Serwisu
                        będą rozstrzygane przez Sąd właściwy według siedziby WHITE SOLUTION.
                    </li>
                    <li>Regulamin obowiązuje od dnia 04.11.2019r.</li>
                </ol>
            </ol>
        </div>
    </main>
</template>

<script>
export default {
    name: "Regulations"
};
</script>

<style lang="scss">
.regulations {
    text-align: justify;

    a {
        color: #85b904;
        font-weight: bold;
    }

    &__list {
        > li {
            font-weight: bold;
            font-size: 20px;
        }

        ol {
            ol {
                list-style: lower-latin;
            }
        }
    }
}
</style>
